// Разбор ответа GET /get-data/tournaments/{tournamentId}
// { title, players: [{ playerId, fullName }],
//   matches: [{ mathId, tournamentId, code, date }],
//   matchPlayers: [{ matchID, playerId, order, point, result: 'WIN' | 'LOSE' | null }] }

export function indexTournament(data) {
    const names = new Map();
    (data?.players ?? []).forEach((p) => names.set(p.playerId, p.fullName));

    const byId = new Map();
    const byCode = new Map();
    (data?.matches ?? []).forEach((m) => {
        // в ответе поле называется mathId; на случай исправления опечатки понимаем и matchId
        const id = m.mathId ?? m.matchId ?? m.id;
        const match = { id, code: m.code, date: m.date ?? null, players: [] };
        byId.set(id, match);
        if (m.code) byCode.set(String(m.code).trim().toUpperCase(), match);
    });

    (data?.matchPlayers ?? []).forEach((mp) => {
        const match = byId.get(mp.matchID ?? mp.matchId);
        if (!match) return;
        match.players.push({
            playerId: mp.playerId,
            name: names.get(mp.playerId) ?? 'Неизвестный игрок',
            order: mp.order ?? null,
            point: mp.point ?? null,
            result: mp.result ? String(mp.result).toUpperCase() : null,
        });
    });

    byCode.forEach((m) => m.players.sort((a, b) => (a.order ?? 99) - (b.order ?? 99)));

    return {
        title: data?.title ?? null,
        playersCount: data?.players?.length ?? 0,
        getMatch: (code) => byCode.get(code) ?? null,
    };
}

// Игрок на месте order (1 — верхняя строка, 2 — нижняя)
export function playerAt(match, order) {
    if (!match) return null;
    const exact = match.players.find((p) => p.order === order);
    if (exact) return exact;
    const noOrder = match.players.every((p) => p.order == null);
    return noOrder ? match.players[order - 1] ?? null : null;
}

export const winnerOf = (match) => match?.players.find((p) => p.result === 'WIN') ?? null;

// Очки показываем, когда матч сыгран или очки уже начислены
export function formatPoints(player) {
    if (!player || player.point == null) return '';
    if (player.result == null && !(player.point > 0)) return '';
    return String(player.point).replace('.', ',');
}

// "2026-10-15" -> "15.10.2026"
export function formatDate(date) {
    if (!date) return '';
    const [year, month, day] = String(date).split('-');
    return year && month && day ? `${day.slice(0, 2)}.${month}.${year}` : String(date);
}

export function plural(n, [one, few, many]) {
    const n10 = n % 10;
    const n100 = n % 100;
    if (n10 === 1 && n100 !== 11) return one;
    if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few;
    return many;
}
